'use es6';

import { connect } from 'react-redux';
import { Fragment, Component } from 'react';
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { ModalTypes } from 'tinymce-plugins/constants/inpage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => {
  // TODO: inpageModals are only setup and used in email, this should eventually
  // be moved into email.
  // Context: https://git.hubteam.com/HubSpot/ContentEditorUI/pull/18383
  const {
    inpageModals
  } = state;
  return {
    modalType: inpageModals.get('modalType')
  };
};

/**
 * @param {Object} props
 * @param {string} [props.modalType] (optional)
 */
class TinyMceModals extends Component {
  constructor(...args) {
    super(...args);
    this.handleTrackFormPickerInteraction = (event, properties = {}) => {
      UsageTracker.trackEditorInteraction(Object.assign({}, properties, {
        action: 'Video Form Picker Action',
        event
      }));
    };
    this.handleVideoInteraction = (action, properties = {}) => {
      UsageTracker.track('tinymceVideo', Object.assign({}, properties, {
        action,
        inline: 'yes',
        type: 'video'
      }));
    };
  }
  render() {
    const {
      modalType
    } = this.props;
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        tinyMceModals: {
          EmbedModalContainer,
          FileManagerModalContainer,
          EditVideoModalContainer,
          VideoPickerContainer,
          HtmlEditorModalContainer,
          CtaPickerContainer,
          GDocPasteModalContainer
        },
        pickerComponents: {
          AsyncCtaPicker,
          AsyncFilePicker,
          AsyncHubSpotVideoPicker
        }
      }) => /*#__PURE__*/_jsxs(Fragment, {
        children: [modalType === ModalTypes.MEDIA_MODAL && /*#__PURE__*/_jsx(EmbedModalContainer, {}), modalType === ModalTypes.FILE_MANAGER && /*#__PURE__*/_jsx(FileManagerModalContainer, {
          FilePicker: AsyncFilePicker
        }), (modalType === ModalTypes.EDIT_VIDEO_MODAL || modalType === ModalTypes.VIDEO_CONVERSION_ASSET_OPTIONS) && /*#__PURE__*/_jsx(EditVideoModalContainer, {
          trackVideoInteraction: this.handleVideoInteraction,
          HubSpotVideoPicker: AsyncHubSpotVideoPicker
        }), modalType === ModalTypes.VIDEO_PICKER && VideoPickerContainer && /*#__PURE__*/_jsx(VideoPickerContainer, {
          HubSpotVideoPicker: AsyncHubSpotVideoPicker
        }), modalType === ModalTypes.CTA && /*#__PURE__*/_jsx(CtaPickerContainer, {
          FilePicker: AsyncFilePicker,
          CtaPicker: AsyncCtaPicker
        }), modalType === ModalTypes.HTML_EDITOR && /*#__PURE__*/_jsx(HtmlEditorModalContainer, {}), modalType === ModalTypes.GDOC_PASTE_MODAL && GDocPasteModalContainer && /*#__PURE__*/_jsx(GDocPasteModalContainer, {})]
      })
    });
  }
}
export default connect(mapStateToProps)(TinyMceModals);